<template>
  <dv-scroll-ranking-board :config="config" style="width:500px;height:300px" />
</template>

<script>
export default {
  name: "ZGRanking",
  data() {
    return {
      config: {},
      //折线数据

      message: {

        data: [
          {
            name: '周口',
            value: 55
          },
          {
            name: '南阳',
            value: 120
          },
          {
            name: '西峡',
            value: 78
          },
          {
            name: '驻马店',
            value: 66
          },
          {
            name: '新乡',
            value: 80
          },
          {
            name: '信阳',
            value: 45
          },
          {
            name: '漯河',
            value: 29
          }
        ],

      },

    }
  },
  methods:{
    init(){
      this.config = this.message
    }
  },
  mounted() {
    //初始化
    this.init();
  },
  created() {
    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };

    this.$api.zga_area_num(data).then(res=>
    {
      this.config ={

        data:res

      }
    })
  },
  watch: {
    message(value) {
      this.init();
    },
  }
}
</script>

<style scoped>

</style>